import React from "react";
import textLogo from "../img/logo-text.png";
import logo from "../img/logo.svg";
import PhoneMenu from "./PhoneMenu";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useStateContext } from "../global-context/useGlobalContext";

const Nav = () => {
  const { pathname } = useLocation();
  const isPhone = useMediaQuery({ maxWidth: 992 });
  const { language, setLanguage } = useStateContext();
  return (
    <NavStyled>
      <Link
        className="logo"
        to="/"
        onClick={() => {
          window.scroll({
            top: 0,
            left: 0,
          });
        }}
      >
        <img
          className="dog"
          src={logo}
          alt="cocker with a monocle"
        />
        <img
          className="text-logo"
          src={textLogo}
          alt="J. Cesar Design text logo"
        />{" "}
      </Link>
      {isPhone ? (
        <PhoneMenu></PhoneMenu>
      ) : (
        <NavPages className="links">
          <Link to="/">
            <h2>
              <Line
                transition={{ duration: 0.75 }}
                intitial={{ width: "0%" }}
                animate={{ width: pathname === "/" ? "60%" : "0%" }}
              />
              {language ? "Accueil" : "Home"}
            </h2>
          </Link>
          <Link to="/projects">
            <h2>
              <Line
                transition={{ duration: 0.75 }}
                intitial={{ width: "0%" }}
                animate={{ width: pathname === "/projects" ? "60%" : "0%" }}
              />
              {language ? "Projets" : "Projects"}
            </h2>
          </Link>
          <Link to="/services">
            <h2>
              <Line
                transition={{ duration: 0.75 }}
                intitial={{ width: "0%" }}
                animate={{ width: pathname === "/services" ? "60%" : "0%" }}
              />
              Services
            </h2>
          </Link>
          <Link to="/contact">
            <h2>
              <Line
                transition={{ duration: 0.75 }}
                intitial={{ width: "0%" }}
                animate={{ width: pathname === "/contact" ? "55%" : "0%" }}
              />
              Contact
            </h2>
          </Link>
          <div className="language">
            <h2
              onClick={() => setLanguage(true)}
              className={language ? `selected` : ""}
            >
              FR
            </h2>
            <h2 className="line">|</h2>
            <h2
              onClick={() => setLanguage(false)}
              className={language ? `` : "selected"}
            >
              EN
            </h2>
          </div>
        </NavPages>
      )}
    </NavStyled>
  );
};

export default Nav;

export const NavStyled = styled.nav`
  width: 100vw;
  height: 12vh;
  position: fixed;
  display: flex;
  justify-content: space-between;
  z-index: 10;
  padding: 0rem 5vw;
  background: transparent;
  backdrop-filter: blur(10px);
  align-items: center;

  @media (max-width: 950px) {
    height: 7vh;
    padding: 0rem 2.5rem;
  }
  .logo {
    flex: 2;
    display: flex;
    align-items: center;
  }
  .dog {
    height: 12vh;
    padding-left: 1vw;
    padding-top: 1vh;
    transform: scaleX(-1);
    @media (max-width: 992px) {
      padding: 0;
      height: 4vh;
    }
  }
  .text-logo {
    padding-left: 1vw;
    height: 3vh;
    @media (max-width: 992px) {
      height: 2vh;
    }
  }
  .links {
    h2:hover {
      color: #f9cc0b;
    }
  }
  h1 {
    @media (max-width: 476px) {
      font-size: 1.5rem;
    }
  }
`;

const NavPages = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 4;
  h2 {
    position: relative;
    font-size: 1.2rem;
    padding-left: 2rem;
    font-weight: 300;
    cursor: pointer;
    color: white;
    @media (max-width: 950px) {
      font-size: 0.8rem;
    }
  }
  .language {
    display: flex;
    flex-direction: row;
    width: 4rem;
    .line {
      color: white;
      :hover {
        color: white;
      }
    }
    h2 {
      padding: 0.2rem;
    }
    .selected {
      color: #f9cc0b;
    }
  }
`;

const Line = styled(motion.div)`
  height: 0.5vh;
  background: #f9cc0b;
  width: 0;
  position: absolute;
  bottom: -30%;
  left: 2rem;
  border-radius: 0.45vh;
  @media (max-width: 950px) {
    bottom: -40%;
    height: 0.4vh;
  }
`;
